export default "__VITE_ASSET__B2wGvX4$__"